var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnketKb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 17.313V2.188c0-1.118-.945-2.063-2.063-2.063H2.063C.903.125 0 1.07 0 2.188v15.124c0 1.16.902 2.063 2.063 2.063h15.124a2.063 2.063 0 0 0 2.063-2.063ZM4.812 7a.679.679 0 0 1-.687-.688V4.938c0-.343.3-.687.688-.687h5.5c.343 0 .687.344.687.688v1.375a.707.707 0 0 1-.688.687h-5.5Zm0 4.125a.679.679 0 0 1-.687-.688V9.063c0-.344.3-.688.688-.688h9.625c.343 0 .687.344.687.688v1.374a.707.707 0 0 1-.688.688H4.813Zm0 4.125a.679.679 0 0 1-.687-.688v-1.374c0-.344.3-.688.688-.688h2.75c.343 0 .687.344.687.688v1.374a.707.707 0 0 1-.688.688h-2.75Z",
    fill: "#E25F6C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnketKb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/anket-kb.8bc5f030c5f15997a0d747fd79fc66f5.svg";